module.exports = __webpack_public_path__ + "img/sol.738e6e62.svg";